import React, { PropsWithChildren } from 'react';
import theme from './LargeRadio.module.scss';
import { classnames } from '@/utils/html';
import { Radio } from '@ygtechnologies/rubus-ui';

interface LargeRadioProps extends PropsWithChildren {
    onChange?(): void;
    checked?: boolean;
    disabled?: boolean;
}
/**
 * Use strong for the header!
 * @param param0
 */
export const LargeRadio: React.FC<LargeRadioProps> = ({ onChange, disabled, checked, children }) => {
    return (
        <Radio checked={checked} onChange={onChange} disabled={disabled} inputSize="md">
            <div className={theme.radioLabel}>{children}</div>
        </Radio>
    );
};
